export default "__VITE_ASSET__CUJ3kv_E__"